/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DataRetention.vue?vue&type=template&id=9f9569e8&"
import script from "./DataRetention.vue?vue&type=script&lang=js&"
export * from "./DataRetention.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports